import { render } from "./MySkills.vue?vue&type=template&id=4a861331&scoped=true"
const script = {}

import "./MySkills.vue?vue&type=style&index=0&id=4a861331&scoped=true&lang=scss"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a861331"]])

export default __exports__